import { render } from "./Pareto.vue?vue&type=template&id=3e6b3df2&scoped=true"
import script from "./Pareto.vue?vue&type=script&lang=js"
export * from "./Pareto.vue?vue&type=script&lang=js"

import "./Pareto.vue?vue&type=style&index=0&id=3e6b3df2&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6b3df2"]])

export default __exports__